<template>
  <span class="feature-value pt-0 pb-0">
    <template v-if="typeof value === 'boolean'">
      <v-icon v-if="value" class="included-icon" size="20">mdi-check</v-icon>
      <span v-else class="excluded-mark" aria-hidden="true">—</span>
      <span class="d-sr-only">{{ value ? includedLabel : notIncludedLabel }}</span>
    </template>
    <template v-else>{{ value }}</template>
  </span>
</template>

<script>

export default {
  name: 'PlanFeatureValue',
  props: {
    value: {
      type: [Boolean, String],
      required: true
    },
    includedLabel: {
      type: String,
      required: true
    },
    notIncludedLabel: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>

@import '@/variables.sass'
$excluded-grey: #999

.included-icon
  color: $green !important

.excluded-mark
  color: $excluded-grey
</style>
